module.exports = __webpack_public_path__ + "img/info_2.fa226f0a.jpg";